import { loadNamespace } from "../helpers/loadNamespace";

export const loadStudentMenuI18n = async () => {
  await loadNamespace("student-common", "student/common.json");
};
